import fetch from "@/api/httpFetch.js";
const apiPrefix = "/openplat-user-server/v";

// 获取用户信息
export function getCompetUser() {
  return fetch.get(`${apiPrefix}/compet2022/getCompetUser`, {
    errorHandler: true
  });
}

// 设置用户身份
export function postCompetUser(params) {
  return fetch.post(`${apiPrefix}/compet2022/postCompetUser`, params);
}

// 获取关卡信息
export function getLevelList() {
  return fetch.get(`${apiPrefix}/getLevelList`, {});
}

// 获取是否展示大赛弹框
export function showCompetWindow(params) {
  return fetch.get(`${apiPrefix}/compet/showCompetWindow`, { params });
}

// 获取排行榜信息
export function ranks(params) {
  return fetch.get(`${apiPrefix}/compet2022/examination/ranks`, { params });
}

// 获取用户信息【第二赛段】
export function getCompetEmp(params) {
  return fetch.get(`${apiPrefix}/undertake/getCompetEmp`, {
    params,
    errorHandler: true
  });
}

// 完善用户信息【第二赛段】
export function putCompetEmp(params) {
  return fetch.post(`${apiPrefix}/undertake/putCompetEmp`, params);
}




// WEBPACK FOOTER //
// ./src/gtn/api/competition/index.js